var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 88,
    viewBox: "0 0 71 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.719 1.11475C25.6776 0.0733479 23.9892 0.0733479 22.9478 1.11475C21.9064 2.15614 21.9064 3.84458 22.9478 4.88598L31.7289 13.6671L22.9479 22.4481C21.9065 23.4895 21.9065 25.1779 22.9479 26.2193C23.9893 27.2607 25.6778 27.2607 26.7192 26.2193L35.5001 17.4383L44.2811 26.2193C45.3225 27.2607 47.0109 27.2607 48.0523 26.2193C49.0937 25.1779 49.0937 23.4895 48.0523 22.4481L39.2714 13.6671L48.0525 4.88598C49.0939 3.84458 49.0939 2.15614 48.0525 1.11475C47.0111 0.0733479 45.3226 0.0733479 44.2812 1.11475L35.5001 9.89588L26.719 1.11475Z",
    fill: "#232224"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3115 42.2192C16.4726 42.2192 14.7634 43.1665 13.7888 44.7259L3.06956 61.8767C1.71589 62.844 0.833496 64.4285 0.833496 66.2191V74.2191C0.833496 81.5829 6.80303 87.5524 14.1668 87.5524H56.8335C64.1973 87.5524 70.1668 81.5829 70.1668 74.2191V66.2191C70.1668 64.1543 68.9935 62.3637 67.2773 61.4773L54.4353 44.3528C53.4281 43.0097 51.8472 42.2192 50.1684 42.2192H18.3115ZM64.1668 66.2191L64.8335 67.108V74.2191C64.8335 78.6374 61.2518 82.2191 56.8335 82.2191H14.1668C9.74855 82.2191 6.16683 78.6374 6.16683 74.2191V66.984L6.64493 66.2191H19.5002V68.8857C19.5002 71.8313 21.888 74.2191 24.8335 74.2191H44.3118C47.2573 74.2191 49.6451 71.8313 49.6451 68.8857V66.2191H64.1668ZM60.1673 60.8857L50.1684 47.5526L18.3115 47.5526L9.97826 60.8857H19.5002C22.4457 60.8857 24.8335 63.2736 24.8335 66.2191V68.8857H44.3118V66.2191C44.3118 63.2736 46.6996 60.8857 49.6451 60.8857H60.1673Z",
    fill: "#232224"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/EmptyState.91be5d398899e0a9c16a8505e82699ea.svg";
export { ForwardRef as ReactComponent };